import React from 'react';
import { Link } from 'react-router-dom';

type AuthPageLayoutProps = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  showBackToLogin?: boolean;
};

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  footer,
  showBackToLogin = false,
}) => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top,_#f6fcf7,_#edf5f0_42%,_#e4ece7_100%)]">
      <div className="pointer-events-none absolute inset-0 opacity-[0.18] [background-size:22px_22px] [background-image:radial-gradient(circle_at_1px_1px,rgba(15,35,24,0.14)_1px,transparent_0)]" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-56 w-[40rem] -translate-x-1/2 rounded-full bg-[#40b93c]/18 blur-3xl" />

      <main className="relative mx-auto flex min-h-screen w-full max-w-3xl items-center justify-center px-5 py-10 sm:px-8">
        <div className="w-full max-w-[520px] rounded-3xl border border-slate-300/95 bg-white/95 p-5 shadow-[0_28px_65px_rgba(15,23,42,0.14)] backdrop-blur-sm sm:p-7">
          <div className="mb-7 flex justify-center">
            <img src="/cosellus-logo.svg" alt="Cosellus" className="h-12 w-auto object-contain" />
          </div>

          {children}

          <div className={`mt-8 border-t border-slate-200 pt-5 text-sm text-slate-500 ${showBackToLogin ? 'text-left' : 'text-center'}`}>
            {showBackToLogin && (
              <p className="mb-2">
                <Link to="/login" className="font-medium text-[#1f4778] hover:underline">
                  &larr; Back to sign in
                </Link>
              </p>
            )}
            {footer}
          </div>
        </div>
      </main>
    </div>
  );
};
